import styled from "styled-components";

export const FooterThreeDesktopCont = styled.section`
  margin-bottom: -35px;

  & .slantPhone {
    margin-top: -10px;
    height: auto;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    /* CSS styles specific to iPads in landscape mode */
    /* Add your styles here */
    &#footerThreeDesktop{margin-bottom: 0}
    & .slantPhone{display: none}
    & .qrApp{margin:inherit}
  }

  & .fasterEasierFree {
    font-size: 26px;
    line-height: 28px;
  }
`;
